<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Calendar Off" class="d-icon d-icon--calendar-off" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><g :clip-path="`url(#${uniqueID}a)`" fill="currentColor"><path d="M4.75 1.5a.5.5 0 0 0 0 1H7.5V3a.5.5 0 0 0 1 0v-.5h1a.5.5 0 0 1 .5.5v1.5H7.75a.5.5 0 0 0 0 1H10v2.25a.5.5 0 0 0 1 0V3a1.5 1.5 0 0 0-1.5-1.5h-1V1a.5.5 0 0 0-1 0v.5H4.75Z"/><path fill-rule="evenodd" clip-rule="evenodd" d="M9.501 11.5a1.5 1.5 0 0 0 .95-.342l.195.196a.5.5 0 0 0 .708-.708l-10-10a.5.5 0 1 0-.708.708l.707.706-.112.126A1.5 1.5 0 0 0 1 3v7a1.5 1.5 0 0 0 1.5 1.5h7.001ZM2 10a.5.5 0 0 0 .5.5h6.999c.082 0 .163-.02.235-.06L4.793 5.5H2V10Zm0-5.5V3a.5.5 0 0 1 .06-.234L3.792 4.5H2Z"/></g><defs><clipPath :id="`${uniqueID}a`"><path fill="#fff" d="M0 0h12v12H0z"/></clipPath></defs></svg>
</template>

<script>
import { getUniqueString } from '@/src/utils';
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconCalendarOff',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
    this.uniqueID = getUniqueString();
  },
};
</script>
